import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/settings/')({
  component: RouteComponent,
  beforeLoad: () => {
    throw redirect({
      to: '/settings/business',
    })
  },
})

function RouteComponent() {
  return (
    <div>
      <h1>Settings</h1>
      <p>Manage your settings here</p>
    </div>
  )
}
